import _ from "lodash";
import React, { useCallback } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";
import { serviceNowVulnerableResponseIssueTypeOptions } from "../jira/JiraMappingForm";

function ServiceNowIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.map((col: any) => {
      if (col.dataIndex === "projectKey") {
        col.title = "Module";
        col.render = (
          projectKey: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => CellRenderers.VALUE_OR_NA(_.startCase(_.toLower(projectKey)));
      }
      if (col.dataIndex === "issueType") {
        col.render = (
          issueType: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          if (record.projectKey === "Vulnerability Response") {
            return serviceNowVulnerableResponseIssueTypeOptions.find(
              (option) => option.value === issueType,
            )!.label;
          }
          return CellRenderers.VALUE_OR_NA(issueType);
        };
      }
      return col;
    });
    return updatedColumns;
  }, []);
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        {...props}
      />
    </div>
  );
}

export default ServiceNowIntegrationListing;
